import React, { useState, useRef, useEffect } from 'react';
import { useGlobalValue } from '../../../state/GlobalProvider';
import { datetime } from '../../../utils';
import Icon from '../../Icon/Icon';
import FileUploaderStatus from './FileUploaderStatus';
import RegularButton from '../RegularButton/RegularButton';
import styles from './FileUploader.module.sass';
import { UserRoles } from '../../../utils/userRoles';
import { checkRoles } from '../../../utils/roleValidator';

const FileUploader = props => {
  const fileInput = useRef(null);
  const dropZone = useRef(null);
  const [dropActive, setDropActive] = useState(false);
  const [files, setFiles] = useState([]);
  const {
    i18n,
    params,
    reload,
    uploads,
    uploadFiles
  } = useGlobalValue();
  const {
    user,
    lastReadTime
  } = props;

  const uploadAllFiles = () => {
    if (files && files.length) {
      uploadFiles && uploadFiles(params.projectId, files).then(() => {
        reload && reload();
      });
    }
  };

  const appendFile = files => {
    uploadFiles && uploadFiles(params.projectId, []);
    setFiles(prevState => {
      const fileList = [...prevState];
      files.forEach(file => {
        if (fileList.findIndex(f => f.name === file.name) < 0) {
          fileList.push(file);
        }
      });
      return fileList.slice(0, 20);
    });
  };

  const handleChange = e => {
    e.preventDefault(e);

    if (params.projectId) {
      const fileList = [...e.target.files];
      fileList && fileList.length && appendFile(fileList);
    }
  };

  const dragChange = e => {
    if (e.type === 'dragenter') {
      setDropActive(true);
    } else if ((e.pageX === 0 || e.pageY === 0) && (e.type === 'dragleave' || e.type === 'dragexit')) {
      setDropActive(false);
    } else if (e.type === 'drop') {
      const inside = dropZone.current && dropZone.current.contains(e.target);
      const files = (e.dataTransfer || {
        files: []
      }).files;
      const fileList = [...files].filter(f => f.type === 'text/txt' || f.type === 'text/csv' || f.type === 'text/xml' || f.type === 'application/zip' || f.type === 'text/plain' || f.type === 'application/pdf' || f.type === 'application/x-zip-compressed');

      if (inside && fileList && fileList.length) {
        appendFile(fileList);
      }

      setDropActive(false);
    }

    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  useEffect(() => {
    document.body.addEventListener('dragover', dragChange);
    document.body.addEventListener('dragenter', dragChange);
    document.body.addEventListener('dragleave', dragChange);
    document.body.addEventListener('dragexit', dragChange);
    document.body.addEventListener('dragstart', dragChange);
    document.body.addEventListener('drop', dragChange);
    return () => {
      document.body.removeEventListener('dragover', dragChange);
      document.body.removeEventListener('dragenter', dragChange);
      document.body.removeEventListener('dragleave', dragChange);
      document.body.removeEventListener('dragexit', dragChange);
      document.body.removeEventListener('dragstart', dragChange);
      document.body.removeEventListener('drop', dragChange);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles['root']
  }, params.section === 'activity' && /*#__PURE__*/React.createElement("div", {
    className: `${styles['content']} ${dropActive ? styles['drop-active'] : ''}`
  }, /*#__PURE__*/React.createElement(FileUploaderStatus, {
    files: files,
    setFiles: setFiles,
    reload: reload
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['file-list']
  }), /*#__PURE__*/React.createElement("div", {
    ref: dropZone,
    className: styles['drop-zone']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: dropActive ? 'clip' : 'upload_file'
  })), /*#__PURE__*/React.createElement("input", {
    ref: fileInput,
    className: styles['file-input'],
    type: "file",
    accept: "text/xml,application/,text/plain,application/pdf,application/zip",
    multiple: true,
    onChange: handleChange
  }), checkRoles(user, [UserRoles.ADMIN, UserRoles.OWNER, UserRoles.WRITER, UserRoles.PP_SUPPORT, UserRoles.SUPPORT]) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, i18n('Drop your files here or'), " "), /*#__PURE__*/React.createElement("button", {
    className: styles['input-button'],
    onClick: () => {
      if (fileInput.current) {
        fileInput.current.value = '';
        fileInput.current.click();
      }
    }
  }, /*#__PURE__*/React.createElement("strong", null, i18n('choose files')))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", {
    className: styles['text-bold']
  }, i18n('Maximum 100MB per file.'), " "))) : /*#__PURE__*/React.createElement("small", null, i18n('You dont have permissions to upload files'), " "))), (files || []).length && !((uploads || []).list || []).some(i => i.progress > 0 && i.progress < 1) ? /*#__PURE__*/React.createElement("div", {
    className: styles['actions-container']
  }, /*#__PURE__*/React.createElement(RegularButton, {
    children: i18n('Upload Files'),
    onClick: uploadAllFiles
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: styles["actions-buttons"]
  }, /*#__PURE__*/React.createElement("div", null, params.section === 'activity' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RegularButton, {
    icon: "refresh",
    onClick: () => reload && reload(),
    iconClassName: `${styles['small-background-color']}`,
    className: `${styles['simple-button']} ${styles['btn-refresh']} ${styles['btn-background-color']}`
  }), /*#__PURE__*/React.createElement("small", {
    className: `${styles['btn-refresh']} ${styles['small-background-color']}`
  }, i18n`Last update:`, " ", lastReadTime && datetime(lastReadTime))))));
};

export default FileUploader;